import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  // ✅ Dark mode (invert)
  const [dark, setDark] = useState(() => localStorage.getItem("theme") === "dark");

  useEffect(() => setMobileOpen(false), [location.pathname]);

  useEffect(() => {
    localStorage.setItem("theme", dark ? "dark" : "light");
    // แนะนำให้ toggle ที่ <html> ครอบทั้งระบบจริง ๆ
    document.documentElement.classList.toggle("invert-mode", dark);
  }, [dark]);

  return (
    <div className="h-screen font-sans text-slate-900 flex overflow-hidden">
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />

      <div className="flex-1 min-w-0 min-h-0 flex flex-col relative">
        {/* ปุ่มสลับโหมด */}
        {/* <button
          onClick={() => setDark((v) => !v)}
          className="fixed bottom-6 right-6 z-[9999] px-4 h-11 rounded-xl bg-slate-900 text-white"
        >
          {dark ? "โหมดสว่าง" : "โหมดมืด"}
        </button> */}

        <main className="flex-1 min-h-0 overflow-y-auto bg-[#F5F5F5] pt-[64px] md:pt-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
